var map = {
	"./about/about3-img.jpg": "cf19",
	"./about/about4-img.jpg": "ff42",
	"./bg/about-bg.png": "320a",
	"./bg/about-details-bg.jpg": "0c1f",
	"./bg/bg-shape.png": "e41f",
	"./bg/blog-background.png": "a907",
	"./bg/contact-background.png": "0fa3",
	"./bg/corporate-background.png": "7e7e",
	"./bg/counter-board-bg.jpg": "bd18",
	"./bg/data-center-bg.jpg": "b265",
	"./bg/data-management-bg.jpg": "638b",
	"./bg/hire-bg.jpg": "8c8e",
	"./bg/page-title-bg.jpg": "c333",
	"./bg/security-bg.jpg": "3a6b",
	"./bg/software-bg.jpg": "20b5",
	"./bg/sorry-bg.jpg": "2170",
	"./brand/agb.png": "f116",
	"./brand/astrazeneca.png": "bcd8",
	"./brand/atm.png": "173a",
	"./brand/bdl.png": "c896",
	"./brand/biopharme.png": "5596",
	"./brand/cisco.png": "d5b2",
	"./brand/citrix.png": "a50f",
	"./brand/ehu.png": "9d54",
	"./brand/emc.png": "c4b6",
	"./brand/eshra.png": "10b9",
	"./brand/forcepoint.png": "12b8",
	"./brand/fortinet.png": "2e05",
	"./brand/fransabank.png": "6bc8",
	"./brand/housingbank.png": "ddc5",
	"./brand/huawei.png": "8a0e",
	"./brand/ibm.png": "1f26",
	"./brand/lapropharm plus.png": "9fda",
	"./brand/lenovo.png": "4e1a",
	"./brand/microsoft.png": "216a",
	"./brand/mobilis.png": "d34f",
	"./brand/nutanix.png": "be31",
	"./brand/ooredoo.png": "800f",
	"./brand/oracle.png": "a9f2",
	"./brand/pharmalliance.png": "0260",
	"./brand/ppg.png": "2f35",
	"./brand/redhat.png": "80f1",
	"./brand/sidi-belabbes.png": "163b",
	"./brand/sophos.png": "a7d4",
	"./brand/veeam.png": "1ae4",
	"./brand/vmware.png": "f1bf",
	"./brand/zimbra.png": "ff5f",
	"./changeAddress.jpg": "fc6c",
	"./close.png": "04b3",
	"./hero/banner1.jpg": "8f30",
	"./hero/banner2.jpg": "4f8b",
	"./hero/banner3.jpg": "0296",
	"./logo/logo-colors-svg.svg": "b2e9",
	"./logo/logo-couleurs.png": "1fa1",
	"./logo/logo-navbar.png": "b31e",
	"./logo/logo-svg.svg": "ec52",
	"./service/service-consulting-1.jpg": "4abf",
	"./service/service-consulting-2.jpg": "f66d",
	"./service/service-consulting-3.jpg": "e0ac",
	"./service/service-data-management-1.jpg": "483b",
	"./service/service-data-management-2.jpg": "e3e3",
	"./service/service-data-management-3.jpg": "2fe5",
	"./service/service-datacenter-2.jpg": "c8f9",
	"./service/service-datacenter-3.jpg": "2b4d",
	"./service/service-datacenter.jpg": "025b",
	"./service/service-professional-services-1.jpg": "b909",
	"./service/service-professional-services-2.jpg": "7603",
	"./service/service-professional-services-3.jpg": "8351",
	"./service/service-security-1.jpg": "81dd",
	"./service/service-security-2.jpg": "4445",
	"./service/service-security-3.jpg": "7b7c",
	"./service/service-software-1.jpg": "9688",
	"./service/service-software-2.jpg": "c052",
	"./service/service-software-3.jpg": "1a24",
	"./shape/about-3-s1.png": "3f27",
	"./shape/about-3-s2.png": "4e7f",
	"./shape/about-3-s3.png": "6303",
	"./shape/about3-main-shape.png": "c22a",
	"./shape/banner3-shape.png": "31b1",
	"./shape/blog-date-shape.png": "0796",
	"./shape/cbg-shape.png": "7fc9",
	"./shape/choosing-m-shape.png": "4c23",
	"./shape/choosing-s1.png": "16b0",
	"./shape/choosing-s2.png": "492e",
	"./shape/dot-dot.png": "578e",
	"./shape/foooter-shape-st-3.png": "2f62",
	"./shape/h3-s1.png": "e470",
	"./shape/hero-s-1.png": "1fea",
	"./shape/hero-s-2.png": "adf7",
	"./shape/logo-bg-1.png": "057d",
	"./shape/member-name-bg.png": "7764",
	"./shape/member-name-c-bg.png": "2a12",
	"./shape/member-shape-st3.png": "ca1f",
	"./shape/menu-bg-1.png": "adbf",
	"./shape/menu-link-shape.png": "1655",
	"./shape/team-s1.png": "f823",
	"./shape/team-s2.png": "e04f",
	"./testimonial/tem-1.jpg": "7f6e",
	"./testimonial/tem-2.png": "c774",
	"./testimonial/tem-3.png": "1abd",
	"./testimonial/test-i-img.jpg": "d1d6",
	"./testimonial/test-r-img.jpg": "4815"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";